import React from 'react'
import Api from './Api';


export default class TransferenciasGlobaisApi {

    Anos = async () => {
        return await Api.get('/transferenciasglobais/anos').then(response => response.data)
            .catch((error) => console.log('[TransferenciasGlobaisApi.Anos]: Error\n', error));
    }

    Ano = async (_ano) => {
        return await Api.get(`/transferenciasglobais/ano/${_ano}`).then(response => response.data)
            .catch((error) => console.log('[TransferenciasGlobaisApi.Ano]: Error\n', error));
        ;
    }

    All = async () => {
        return await Api.get('transferenciasglobais').then(response => response.data)
            .catch(error => console.log('[TransferenciasGlobaisApi.all]: Error\n', error))
            ;
    }



}

